import { reactive } from '@vue/composition-api';

const state = reactive({
    title: null,
    mainPhone: null,
    phones: [],
});

export const setTitle = (title) => {
    state.title = title;
};

export const setPhones = (phones) => {
    state.phones = phones;
};

export const setmainPhone = (mainPhone) => {
    state.mainPhone = mainPhone;
};

export const getState = {
    state,
};
